import AvatarFallback from "./AvatarFallback";
import React from "react";
import { Box, Typography } from "@mui/material";
import { MoreHorizontalIcon } from "../AdaptiveIcon";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";

const Reddit = ({
  selectedAccounts,
  formattedTags,
  accResp,
  selectedImages,
  selectedIndex,
  avatars,
  postTitle,
  postText,
}) => {
  const numImages = selectedImages.length;

  let gridColumns;
  let gridRows;

  if (numImages === 1) {
    gridColumns = "auto";
    gridRows = "auto";
  } else if (numImages === 2) {
    gridColumns = "1fr 1fr";
    gridRows = "50%";
  } else if (numImages === 3) {
    gridColumns = "auto minmax(33.33%, 1fr)";
    gridRows = "50% 50%";
  } else if (numImages >= 4) {
    gridColumns = "auto minmax(33.33%, 1fr)";
    gridRows = "repeat(3, 33.33%)";
  }

  return (
    <Box className="tab-pane h-full">
      <Box className="user-container p-10 relative mx-5">
        <Box
          className="instHeader mt-4"
          sx={{
            height: "20px",
            position: "relative",
            marginBottom: selectedAccounts.length === 0 ? "0px" : "30px",
          }}>
          {selectedAccounts.length === 0 ? (
            <Box
              className="avatar"
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "var(--background-preview)",
                position: "absolute",
              }}
            />
          ) : (
            <>
              {selectedAccounts.map((id, i) => {
                const index = accResp.findIndex((acc) => acc.id === id);
                const avatar = avatars[index];
                const userName = accResp[index].username;

                return (
                  <Box
                    key={id}
                    className="author-img"
                    sx={{
                      backgroundColor: "var(--background-preview)",
                      position: "absolute",
                      display: i === selectedIndex ? "flex" : "none",
                      alignItems: "center",
                    }}>
                    <AvatarFallback
                      src={avatar}
                      name={userName}
                      background="#ff4500"
                      className="w-full h-full object-cover mr-2"
                      style={{ borderRadius: "50%" }}
                    />
                    <Box className="flex items-center">
                      <Typography
                        className="whitespace-nowrap"
                        sx={{
                          marginLeft: "10px",
                          color: "var(--text-color)",
                        }}>
                        u/{userName}
                      </Typography>
                      <Typography
                        className="whitespace-nowrap"
                        sx={{
                          color: "#a9a9a9",
                          fontSize: "12px",
                        }}>
                        ・1 min. ago
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </>
          )}
          <Box className="absolute right-0">
            <MoreHorizontalIcon fontSize="large" />
          </Box>
        </Box>
        <Box
          className="user-info"
          style={{ position: "relative", paddingLeft: "60px", top: "-25px" }}>
          {selectedAccounts.length === undefined ||
          selectedAccounts.length === 0 ? (
            <>
              <Box
                style={{
                  width: "30%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
              <Box
                style={{
                  width: "10%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}
              />
            </>
          ) : null}
        </Box>

        {(postTitle === undefined || postTitle === "") &&
        selectedImages.length === 0 ? (
          <Box className="flex flex-col mb-8">
            <Box sx={{ width: "100%", display: "block", alignSelf: "center" }}>
              <Box
                style={{
                  width: "100%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "30%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
            </Box>
          </Box>
        ) : (
          <Box className="mb-3">
            <Typography
              component="div"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                marginBottom: "5px",
                color: "var(--text-color)",
              }}>
              {postTitle}
            </Typography>
          </Box>
        )}

        {postText === undefined || postText === "" ? (
          <Box className="flex flex-col mb-2">
            <Box sx={{ width: "85%", display: "block", alignSelf: "center" }}>
              <Box
                style={{
                  width: "100%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "70%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
              <Box
                style={{
                  width: "50%",
                  height: "12px",
                  backgroundColor: "var(--background-preview)",
                  marginBottom: "5px",
                }}></Box>
            </Box>
          </Box>
        ) : (
          <>
            <Typography
              component="div"
              style={{
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                marginBottom: "5px",
                color: "var(--text-color)",
                fontSize: "14px",
                lineHeight: "1.5",
              }}>
              {postText}
            </Typography>
            <Typography
              component="div"
              style={{
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                marginBottom: "5px",
                color: "#ff4500",
              }}>
              {formattedTags}
            </Typography>
          </>
        )}

        {selectedImages.length > 0 && (
          <Box className="flex justify-center">
            <Box style={{ width: "523px", height: "523px" }}>
              <Box
                className={`media-preview-template ${
                  numImages > 4 ? "overflow" : ""
                }`}
                style={{
                  gridTemplateColumns: gridColumns,
                  gridTemplateRows: gridRows,
                }}>
                {selectedImages.slice(0, 1).map((image, index) => (
                  <img
                    key={index}
                    src={image.props.src}
                    alt="Selected"
                    style={{
                      gridArea: "1 / 2 / span 2 / span 2",
                      width: "523px",
                      height: "523px",
                    }}
                  />
                ))}
                {selectedImages.slice(1, 5).map((image, index) => (
                  <img key={index + 1} src={image.props.src} alt="Selected" />
                ))}
                {numImages > 5 && (
                  <Box className="last-image-overlay">
                    <Typography className="numImages" component="span">
                      +{numImages - 5}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        )}
        {/* Reddit action bar */}
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          marginTop: "12px",
          paddingTop: "8px",
          borderTop: "1px solid var(--border-color)",
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            background: "var(--background-preview)",
            borderRadius: "20px",
            padding: "4px 10px",
            gap: "6px",
          }}>
            <ArrowUpwardRoundedIcon sx={{ fontSize: "18px", color: "#ff4500", cursor: "pointer" }} />
            <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "var(--text-color)" }}>1.2k</Typography>
            <ArrowDownwardRoundedIcon sx={{ fontSize: "18px", color: "#a9a9a9", cursor: "pointer" }} />
          </Box>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            background: "var(--background-preview)",
            borderRadius: "20px",
            padding: "4px 10px",
            gap: "6px",
            cursor: "pointer",
          }}>
            <ChatBubbleOutlineRoundedIcon sx={{ fontSize: "16px", color: "#a9a9a9" }} />
            <Typography sx={{ fontSize: "13px", color: "var(--text-color)" }}>86</Typography>
          </Box>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            background: "var(--background-preview)",
            borderRadius: "20px",
            padding: "4px 10px",
            gap: "6px",
            cursor: "pointer",
          }}>
            <ShareOutlinedIcon sx={{ fontSize: "16px", color: "#a9a9a9" }} />
            <Typography sx={{ fontSize: "13px", color: "var(--text-color)" }}>Share</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Reddit;
